module.exports = __webpack_public_path__ + "static/media/success_tick.f9b06095.png";